import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import StatCard from './StatCard'
import FormattingUtils from 'shared/FormattingUtils'

const SectionContainer = styled.div`
  ${(props) => props.theme.baseCard};
  display: flex;
  flex-direction: column;
`

const SectionHeader = styled.div`
  margin-bottom: 0.625rem;
`

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    grid-template-columns: 1fr;
  }
`

const ThisMonthStatsSection: React.FC = () => {
  // Hardcoded values for demo (in cents for formatDollar)
  const totalSpent = 15200
  const taxSavings = 4700
  const tripsTaken = 23
  const envSavings = 67
  const tripsBreakdown = '18 transit, 5 bike'

  return (
    <SectionContainer>
      <SectionHeader>
        <Text variant='h4'>This Month</Text>
      </SectionHeader>

      <StatsGrid>
        <StatCard
          label='Total Spent'
          value={FormattingUtils.formatDollar(totalSpent)}
          change='12% from last month'
          changeDirection='down'
        />
        <StatCard
          label='Tax Savings'
          value={FormattingUtils.formatDollar(taxSavings)}
          change='$12 from last month'
          changeDirection='up'
        />
        <StatCard
          label='Trips Taken'
          value={tripsTaken}
          breakdown={tripsBreakdown}
        />
        <StatCard
          label='CO₂ Avoided'
          value={`${envSavings} kg`}
          breakdown='vs. driving alone'
        />
      </StatsGrid>
    </SectionContainer>
  )
}

export default React.memo(ThisMonthStatsSection)
